import { z } from 'zod';

export const marketingConsentTextResponseSchema = z.object({
  version: z.number(),
  text: z.array(z.string()),
});
